export default "__VITE_ASSET__CJgFWK2C__"